import { lazy, Suspense } from 'react';
import { App as AntdApp } from 'antd';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from './app/Layout';
import './App.css';

const ObjectsPage = lazy(() => import('./pages/objects/ObjectsPage'));
const ObjectPage = lazy(() => import('./pages/object/ObjectPage'));
const RentsPage = lazy(() => import('./pages/rents/RentsPage'));
const CanceledRentsPage = lazy(() => import('./pages/canceled_rents/CanceledRentsPage'));
const CleanersPage = lazy(() => import('./pages/cleaners/CleanersPage'));
const LoginPage = lazy(() => import('./pages/login/LoginPage'));
const BusinessPage = lazy(() => import('./pages/business/BusinessPage'));
const CleansPage = lazy(() => import('./pages/cleans/CleansPage'));
const PlanCleansPage = lazy(() => import('./pages/cleans_plan/PlanCleansPage'));
const CleanersReportPage = lazy(() => import('./pages/cleans_report/CleanersReportPage'));
const TemplatesPage = lazy(() => import('./pages/templates/TemplatesPage'));
const OwnersPage = lazy(() => import('./pages/owners/OwnersPage'));
const OwnerPage = lazy(() => import('./pages/owner/OwnerPage'));
const CleanerPage = lazy(() => import('./pages/cleaner/CleanerPage'));
const OnboardingPage = lazy(() => import('./pages/onboarding/OnboardingPage'));
const TasksPage = lazy(() => import('./pages/tasks/TasksPage'));
const UpdatesPage = lazy(() => import('./pages/updates/UpdatesPage'));
const InstructionsPage = lazy(() => import('./pages/instructions/InstructionsPage'));
const ProfilePage = lazy(() => import('./pages/profile/ProfilePage'));
const ClientTasksPage = lazy(() => import('./pages/client_tasks/ClientTasksPage'));
const StatisticsPage = lazy(() => import('./pages/statistics/StatisticsPage'));
const DashboardPage = lazy(() => import('./pages/dashboard/DashboardPage'));
const AutomessagesPage = lazy(() => import('./pages/automessages/AutomessagesPage'));
const MetersPage = lazy(() => import('./pages/meters/MetersPage'));
const PapertrailsPage = lazy(() => import('./pages/papertrails/PapertrailsPage'));
const ChatsPage = lazy(() => import('./pages/chats/ChatsPage'));

const routesConfig = [
  {
    path: '/login',
    element: (
      <Suspense fallback={<div>...</div>}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: '/owner/:id',
    element: <OwnerPage />,
  },
  {
    path: '/cleaner/:id',
    element: <CleanerPage />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <DashboardPage />,
        handle: { menuKey: 'dashboard' },
      },
      {
        path: '/onboarding',
        element: <OnboardingPage />,
      },
      {
        path: '/objects',
        element: <ObjectsPage />,
        handle: { menuKey: 'objects' },
      },
      {
        path: '/instructions',
        element: <InstructionsPage />,
        handle: { menuKey: 'instructions' },
      },
      {
        path: '/objects/:id',
        element: <ObjectPage />,
        handle: { menuKey: 'objects' },
      },
      {
        path: '/rents',
        element: <RentsPage />,
        handle: { menuKey: 'rents' },
      },
      {
        path: '/canceled_rents',
        element: <CanceledRentsPage />,
      },
      {
        path: '/rents/:id',
        element: <RentsPage />,
        handle: { menuKey: 'rents' },
      },
      {
        path: '/cleaners',
        element: <CleanersPage />,
        handle: { menuKey: 'cleaners' },
      },
      {
        path: '/cleaners/:id',
        element: <CleanerPage />,
        handle: { menuKey: 'cleaners' },
      },
      {
        path: '/cleans',
        element: <CleansPage />,
        handle: { menuKey: 'cleans' },
      },
      {
        path: '/cleans/plan',
        element: <PlanCleansPage />,
        handle: { menuKey: 'cleans' },
      },
      {
        path: '/cleans/report',
        element: <CleanersReportPage />,
        handle: { menuKey: 'cleans' },
      },
      {
        path: '/cleans/:id',
        element: <CleansPage />,
        handle: { menuKey: 'cleans' },
      },
      {
        path: '/business',
        element: <BusinessPage />,
        handle: { menuKey: 'business' },
      },
      {
        path: '/templates',
        element: <TemplatesPage />,
      },
      {
        path: '/owners',
        element: <OwnersPage />,
        handle: { menuKey: 'owners' },
      },
      {
        path: '/tasks',
        element: <TasksPage />,
        handle: { menuKey: 'tasks' },
      },
      {
        path: '/automessages',
        element: <AutomessagesPage />,
      },
      {
        path: '/meters',
        element: <MetersPage />,
        handle: { menuKey: 'meters' },
      },
      {
        path: '/updates',
        element: <UpdatesPage />,
      },
      {
        path: '/profile',
        element: <ProfilePage />,
        handle: { menuKey: 'profile' },
      },
      {
        path: '/statistics',
        element: <StatisticsPage />,
      },
      {
        path: '/dashboard',
        element: <DashboardPage />,
        handle: { menuKey: 'dashboard' },
      },
      {
        path: '/clienttasks',
        element: <ClientTasksPage />,
        handle: { menuKey: 'clienttasks' },
      },
      {
        path: '/papertrails',
        element: <PapertrailsPage />,
      },
      {
        path: '/chats',
        element: <ChatsPage />,
        handle: { menuKey: 'chats' },
      },
    ],
  },
];

const router = createBrowserRouter(routesConfig);

function App() {
  return (
    <div className="App">
      <AntdApp>
        <RouterProvider router={router} />
      </AntdApp>
    </div>
  );
}

export default App;
